export default __webpack_public_path__ + "static/media/spider.d0b51ad5.png";